export default "__VITE_ASSET__AhccF6Mt__"